<template>
  <span :class="['cv-spinner', { 'cv-spinner--large': large }]" role="status">
    <span class="sr-only">{{ label }}</span>
  </span>
</template>

<script>
// The Custom Validations screens' loading spinner. Bootstrap's own spinner styles aren't part of this
// app's build (assets/sass/argon.scss doesn't import them), so <b-spinner> draws nothing - other
// screens use their own too (the BDX export buttons, the BDX Validation report). Takes the text colour.
export default {
  name: 'CvSpinner',
  props: {
    large: { type: Boolean, default: false }, // for a spinner on its own, e.g. over the formula box
    label: { type: String, default: 'Loading' } // read by screen readers only
  }
}
</script>

<style>
.cv-spinner {
  display: inline-block;
  width: 0.9em;
  height: 0.9em;
  vertical-align: -0.125em;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: cv-spinner-turn 0.75s linear infinite;
}

.cv-spinner--large {
  width: 2rem;
  height: 2rem;
  border-width: 3px;
}

@keyframes cv-spinner-turn {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .cv-spinner {
    animation-duration: 1.5s;
  }
}
</style>
